import axios from 'axios'
const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

export const fetchAccountStatusList = (module: string, params: any) =>
  axios.get(`${API_URL}/account-status/${module}`, { params })
